module.exports = __webpack_public_path__ + "f2e68898d97ec3b51f6e8ca1e3fd95c0.MP3";